import imgElyon81 from "./elyon8 (1).png";
import imgElyon82 from "./elyon8 (2).png";
import imgElyon83 from "./elyon8 (3).png";
import imgElyon84 from "./elyon8 (4).png";
import imgElyon85 from "./elyon8 (5).png";

const imgElyon8 = [imgElyon81, imgElyon82, imgElyon83, imgElyon84, imgElyon85];

export default imgElyon8;
